var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('ContentBlock',{attrs:{"data":_vm.contentConfig[0]}}),_c('ContentBlock',{attrs:{"data":_vm.contentConfig[1]}}),_c('ContentBlock',{attrs:{"data":_vm.contentConfig[2]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }